import { useSelector } from 'react-redux';

export const selectIsTaskPaneUpdateEnabled = (_state: any): boolean => {
  return true; // Making mini update enabled by default
};

export const useTaskPaneUpdateMiniEnabled = (): boolean => {
  return useSelector(selectIsTaskPaneUpdateEnabled);
};
